var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletcopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0806 6.55859H7.7804C7.00719 6.55859 6.38037 7.18539 6.38037 7.95859V14.2586C6.38037 15.0318 7.00719 15.6586 7.7804 15.6586H14.0806C14.8538 15.6586 15.4806 15.0318 15.4806 14.2586V7.95859C15.4806 7.18539 14.8538 6.55859 14.0806 6.55859Z",
    stroke: "#FF6C00",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58049 10.7582H2.88048C2.50918 10.7582 2.15308 10.6107 1.89052 10.3481C1.62797 10.0856 1.48047 9.72948 1.48047 9.35818V3.0582C1.48047 2.6869 1.62797 2.3308 1.89052 2.06825C2.15308 1.8057 2.50918 1.6582 2.88048 1.6582H9.18055C9.55186 1.6582 9.90796 1.8057 10.1705 2.06825C10.4331 2.3308 10.5806 2.6869 10.5806 3.0582V3.7582",
    stroke: "#FF6C00",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletcopy);
export default __webpack_public_path__ + "static/media/walletcopy.92f16bdce2bb6e64385b53291684414b.svg";
export { ForwardRef as ReactComponent };